((w, d) => {
    window.addEventListener('DOMContentLoaded', () => {
        const filterheading = d.getElementById('filterheading');
        const scroll = /\/(seite-|kategorie\/|sortierung\/)/.test(window.location.pathname);

        if (filterheading && scroll) {
            filterheading.focus();
            filterheading.scrollIntoView({ behavior: 'smooth' });
        }
    });
})(window, document);


